import React from 'react';
import {
  Grid,
  Typography,
  Divider,
  Button,
  Box,
  TextField
} from '@mui/material';
import { grey } from '@mui/material/colors';
import {
  formatDateUTCFormat,
  formatNumberWithCommas,
  getOrdinal
} from '../apis/Utils';

const TLShipmentPreview = ({
  shipmentsDetails = [],
  groupedPickupDetails = {},
  groupedDeliveryDetails = {},
  previousRowDetails = {},
  quoteMode = '',
  pickupDetailsArr = [],
  deliveryDetailsArr = [],
  setPickupDetailsArr,
  setDeliveryDetailsArr,
  PreviousProps,
  companyRefs,
  phoneRefs,
  deliveryCompanyRefs,
  deliveryPhoneRefs,
  currentValidationIndex,
  pickupValidationErrors,
  deliveryCurrentValidationIndex,
  deliveryValidationErrors,
  setPickupValidationErrors,
  setDeliveryValidationErrors,
  formatPhoneNumber,
  emailRegex
}) => {
  // Ordinal logic
  const shouldUseOrdinal = type => {
    if (type === 'Pickup') {
      const isSingle =
        quoteMode?.includes('1 Pickup') || quoteMode?.includes('Single');
      return !isSingle;
    }
    const isSingle =
      quoteMode?.includes('1 Drop') || quoteMode?.includes('Single');
    return !isSingle;
  };

  // ✅ FIX: Render item details card - MATCHING HEADER STYLES
  const renderItemDetailsCard = (item, type) => (
    <Grid
      container
      //   spacing={2}
      sx={{
        p: 2,
        // mt: 2,
        backgroundColor: '#EEF4FC',
        borderRadius: 2,
        width: '98%'
      }}
    >
      <Grid
        sx={{
          width: '98%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 1
        }}
      >
        {item.itemType === 'Pickup' && (
          <Grid>
            <div className='label'>Net Weight (lbs)</div>
            <div className='lable-text'>
              {formatNumberWithCommas(item.netWeight)}
            </div>
          </Grid>
        )}
        <Grid>
          <div className='label'>Gross Weight (lbs)</div>
          <div className='lable-text'>
            {formatNumberWithCommas(item.grossWeight)}
          </div>
        </Grid>
        <Grid>
          <div className='label'>Handling Unit</div>
          <div className='lable-text'>{item.packagingType}</div>
        </Grid>
        <Grid>
          <div className='label'># of Handling Unit</div>
          <div className='lable-text'>{item.units || item.pallets}</div>
        </Grid>
        {item.itemType === 'Pickup' && (
          <>
            <Grid>
              <div className='label'>Dimensions (in)</div>
              <div className='lable-text'>
                {item.length} x {item.width} x {item.height}
              </div>
            </Grid>
            <Grid>
              <div className='label'>Stackable?</div>
              <div className='lable-text'>
                {item.isStackable ? 'Yes' : 'No'}
              </div>
            </Grid>
          </>
        )}
        {type === 'Pickup' && (
          <Grid>
            <div className='label'>Freight Class</div>
            <div className='lable-text'>{item.freightClass}</div>
          </Grid>
        )}
      </Grid>
      <Grid sx={{ display: 'flex', mt: 2, width: '98%' }}>
        <div className='label'>Item Description</div>
      </Grid>
      <div className='lable-text' style={{ width: '98%', mt: 0.5 }}>
        {item.itemDescription || item.itemText}
      </div>
    </Grid>
  );

  // Helper: Render address card - MATCHING HEADER STYLES
  const renderAddressCard = (item, index, type) => {
    const isMultiMode = shouldUseOrdinal(type);
    const displayType = type === 'Drop' ? 'Delivery' : type;

    return (
      <Grid
        sx={{
          p: 2,
          mt: 2,
          backgroundColor: '#EEF4FC',
          borderRadius: 2,
          width: '98%'
        }}
      >
        <div className='label' style={{ fontWeight: 600 }}>
          {isMultiMode
            ? `${getOrdinal(index + 1)} ${displayType} Address`
            : `${displayType} Address`}
        </div>
        <div className='lable-text' style={{ mt: 0.5 }}>
          {[
            item?.company,
            item?.address,
            item?.city,
            item?.state,
            item?.zip,
            item?.country
          ]
            .filter(Boolean)
            .join(', ') || 'No address available'}
        </div>

        <Grid container sx={{ display: 'flex', mt: 2 }} spacing={3}>
          {type === 'Pickup' ? (
            <>
              <Grid item>
                <div className='label'>Pickup Date</div>
                <div className='lable-text'>
                  {formatDateUTCFormat(item?.pickupDate)}
                </div>
              </Grid>
              <Grid item>
                <div className='label'>Pickup Hours</div>
                <div className='lable-text'>
                  {item?.openTime} - {item?.closeTime}
                </div>
              </Grid>
              <Grid item>
                <div className='label'>Exp Delivery Date</div>
                <div className='lable-text'>
                  {formatDateUTCFormat(item?.expectedDeliveryDate)}
                </div>
              </Grid>
            </>
          ) : (
            <>
              <Grid item>
                <div className='label'>Exp. Delivery Date</div>
                <div className='lable-text'>
                  {formatDateUTCFormat(item?.expectedDeliveryDate)}
                </div>
              </Grid>
              <Grid item>
                <div className='label'>Delivery Hours</div>
                <div className='lable-text'>
                  {item?.openTime} - {item?.closeTime}
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    );
  };

  // Helper: Render contact details for Pickup - MATCHING HEADER STYLES
  const renderPickupContactDetails = (contactItem, index) => (
    <Box key={contactItem?.id || `pickup-contact-${index}`} sx={{ mt: 2 }}>
      <Grid sx={{ display: 'flex', mt: 1 }}>
        <b style={{ color: '#2563eb' }}>Pickup Contact Details</b>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 1,
          backgroundColor: '#EEF4FC',
          p: 2,
          borderRadius: 2,
          width: '98%'
          //   '& .MuiInputLabel-root': { fontSize: '13px' },
          //   '& .MuiInputBase-input': { fontSize: '13px' }
        }}
      >
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            sx={{ backgroundColor: 'white' }}
            label='Contact Name'
            variant='outlined'
            size='small'
            value={contactItem?.contactPerson || ''}
            onChange={e => {
              const updatedDetails = pickupDetailsArr.map((item, i) =>
                i === index ? { ...item, contactPerson: e.target.value } : item
              );
              setPickupDetailsArr(updatedDetails);
            }}
          />
        </Grid>
        {PreviousProps?.freightTerms === 'OutboundPrepaid' && (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
              inputRef={el => (companyRefs.current[index] = el)}
              fullWidth
              sx={{ backgroundColor: 'white' }}
              label='Company'
              variant='outlined'
              size='small'
              value={contactItem?.company || ''}
              error={
                index === currentValidationIndex &&
                !!pickupValidationErrors?.[index]?.company
              }
              helperText={
                index === currentValidationIndex
                  ? pickupValidationErrors?.[index]?.company
                  : ''
              }
              onChange={e => {
                const updatedDetails = pickupDetailsArr.map((item, i) =>
                  i === index ? { ...item, company: e.target.value } : item
                );
                setPickupDetailsArr(updatedDetails);
                if (
                  index === currentValidationIndex &&
                  setPickupValidationErrors
                ) {
                  setPickupValidationErrors(prev => {
                    const updatedErrors = [...(prev || [])];
                    if (!updatedErrors[index]) updatedErrors[index] = {};
                    updatedErrors[index].company = '';
                    return updatedErrors;
                  });
                }
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            inputRef={el => (phoneRefs.current[index] = el)}
            fullWidth
            sx={{ backgroundColor: 'white' }}
            label='Phone Number'
            variant='outlined'
            size='small'
            value={formatPhoneNumber(contactItem?.contactPhone || '')}
            error={
              index === currentValidationIndex &&
              !!pickupValidationErrors?.[index]?.contactPhone
            }
            helperText={
              index === currentValidationIndex
                ? pickupValidationErrors?.[index]?.contactPhone
                : ''
            }
            onChange={e => {
              const updatedDetails = pickupDetailsArr.map((item, i) =>
                i === index
                  ? { ...item, contactPhone: formatPhoneNumber(e.target.value) }
                  : item
              );
              setPickupDetailsArr(updatedDetails);
              if (
                index === currentValidationIndex &&
                setPickupValidationErrors
              ) {
                setPickupValidationErrors(prev => {
                  const updatedErrors = [...(prev || [])];
                  if (!updatedErrors[index]) updatedErrors[index] = {};
                  updatedErrors[index].contactPhone = '';
                  return updatedErrors;
                });
              }
            }}
            inputProps={{ maxLength: 14 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            sx={{ backgroundColor: 'white' }}
            label='Email Address'
            variant='outlined'
            size='small'
            error={!!pickupDetailsArr?.[index]?.emailError}
            helperText={pickupDetailsArr?.[index]?.emailError || ''}
            value={contactItem?.contactEmail || ''}
            onChange={e => {
              const value = e.target.value;
              const isValid = emailRegex?.test(value) ?? true;
              const updatedDetails = pickupDetailsArr.map((item, i) =>
                i === index
                  ? {
                      ...item,
                      contactEmail: value,
                      emailError:
                        value && !isValid ? 'Enter a valid email address' : ''
                    }
                  : item
              );
              setPickupDetailsArr(updatedDetails);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );

  // Helper: Render contact details for Delivery - MATCHING HEADER STYLES
  const renderDeliveryContactDetails = (contactItem, index) => (
    <Box key={contactItem?.id || `delivery-contact-${index}`} sx={{ mt: 2 }}>
      <Grid sx={{ display: 'flex', mt: 1 }}>
        <b style={{ color: '#2563eb' }}>Delivery Contact Details</b>
      </Grid>
      <Grid
        sx={{
          p: 2,
          mt: 2,
          backgroundColor: '#EEF4FC',
          borderRadius: 2,
          width: '98%'
        }}
      >
        <Grid
          spacing={2}
          sx={{
            display: 'flex',
            mt: 1,
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 1
          }}
        >
          <Grid>
            <TextField
              sx={{ width: '20vw', backgroundColor: 'white' }}
              label='Contact Name'
              variant='outlined'
              size='small'
              value={contactItem?.contactPerson || ''}
              onChange={e => {
                const updatedDetails = deliveryDetailsArr.map((item, i) =>
                  i === index
                    ? { ...item, contactPerson: e.target.value }
                    : item
                );
                setDeliveryDetailsArr(updatedDetails);
              }}
            />
          </Grid>
          {PreviousProps?.freightTerms === 'InboundCollect' && (
            <Grid>
              <TextField
                inputRef={el => (deliveryCompanyRefs.current[index] = el)}
                sx={{ width: '20vw', backgroundColor: 'white' }}
                label='Company'
                variant='outlined'
                size='small'
                value={contactItem?.company || ''}
                error={
                  index === deliveryCurrentValidationIndex &&
                  !!deliveryValidationErrors?.[index]?.company
                }
                helperText={
                  index === deliveryCurrentValidationIndex
                    ? deliveryValidationErrors?.[index]?.company
                    : ''
                }
                onChange={e => {
                  const updatedDetails = deliveryDetailsArr.map((item, i) =>
                    i === index ? { ...item, company: e.target.value } : item
                  );
                  setDeliveryDetailsArr(updatedDetails);
                  if (
                    index === deliveryCurrentValidationIndex &&
                    setDeliveryValidationErrors
                  ) {
                    setDeliveryValidationErrors(prev => {
                      const updatedErrors = [...(prev || [])];
                      if (!updatedErrors[index]) updatedErrors[index] = {};
                      updatedErrors[index].company = '';
                      return updatedErrors;
                    });
                  }
                }}
              />
            </Grid>
          )}
          <Grid>
            <TextField
              inputRef={el => (deliveryPhoneRefs.current[index] = el)}
              sx={{ width: '20vw', backgroundColor: 'white' }}
              label='Phone Number'
              variant='outlined'
              size='small'
              value={formatPhoneNumber(contactItem?.contactPhone || '')}
              error={
                index === deliveryCurrentValidationIndex &&
                !!deliveryValidationErrors?.[index]?.contactPhone
              }
              helperText={
                index === deliveryCurrentValidationIndex
                  ? deliveryValidationErrors?.[index]?.contactPhone
                  : ''
              }
              onChange={e => {
                const updatedDetails = deliveryDetailsArr.map((item, i) =>
                  i === index
                    ? {
                        ...item,
                        contactPhone: formatPhoneNumber(e.target.value)
                      }
                    : item
                );
                setDeliveryDetailsArr(updatedDetails);
                if (
                  index === deliveryCurrentValidationIndex &&
                  setDeliveryValidationErrors
                ) {
                  setDeliveryValidationErrors(prev => {
                    const updatedErrors = [...(prev || [])];
                    if (!updatedErrors[index]) updatedErrors[index] = {};
                    updatedErrors[index].contactPhone = '';
                    return updatedErrors;
                  });
                }
              }}
              inputProps={{ maxLength: 14 }}
            />
          </Grid>
          <Grid>
            <TextField
              sx={{ width: '20vw', backgroundColor: 'white' }}
              label='Email Address'
              variant='outlined'
              size='small'
              error={!!deliveryDetailsArr?.[index]?.emailError}
              helperText={deliveryDetailsArr?.[index]?.emailError || ''}
              value={contactItem?.contactEmail || ''}
              onChange={e => {
                const value = e.target.value;
                const isValid = emailRegex?.test(value) ?? true;
                const updatedDetails = deliveryDetailsArr.map((item, i) =>
                  i === index
                    ? {
                        ...item,
                        contactEmail: value,
                        emailError:
                          value && !isValid ? 'Enter a valid email address' : ''
                      }
                    : item
                );
                setDeliveryDetailsArr(updatedDetails);
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

  // Helper: Render instructions - MATCHING HEADER STYLES
  const renderInstructionsSection = () => {
    const hasPickupInstructions = PreviousProps?.pickupInstructions;
    const hasDeliveryInstructions = PreviousProps?.deliveryInstructions;

    if (!hasPickupInstructions && !hasDeliveryInstructions) return null;

    return (
      <Grid container spacing={2} sx={{ mt: 2, display: 'flex' }}>
        {hasPickupInstructions && (
          <Grid item md={5.9} lg={5.9} xl={5.9}>
            <b style={{ color: '#2563eb', marginTop: 5 }}>
              Pickup Instructions
            </b>
            <Grid
              container
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderRadius: 2,
                p: 2,
                backgroundColor: '#EEF4FC',
                width: '98%'
              }}
            >
              <div className='lable-text'>
                {PreviousProps?.pickupInstructions}
              </div>
            </Grid>
          </Grid>
        )}
        {hasDeliveryInstructions && (
          <Grid item md={5.9} lg={5.9} xl={5.9}>
            <b style={{ color: '#2563eb', marginTop: 5 }}>
              Delivery Instructions
            </b>
            <Grid
              container
              sx={{
                display: 'flex',
                p: 2,
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#EEF4FC',
                borderRadius: 2,
                width: '98%'
              }}
            >
              <div className='lable-text'>
                {PreviousProps?.deliveryInstructions}
              </div>
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  };

  // Main: Render complete location block
  const renderLocationBlock = (items, index, type, isGlobalFirst) => {
    const firstItem = items[0];
    const isMultiMode = shouldUseOrdinal(type);
    const displayType = type === 'Drop' ? 'Delivery' : type;
    const label = isMultiMode
      ? `${getOrdinal(index + 1)} ${displayType}`
      : `${displayType}`;

    return (
      <Grid item xs={12} key={`${type}-${index}`} sx={{ mb: 3 }}>
        {/* Section Header */}
        <Grid
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 1,
            mb: 1
          }}
        >
          <b style={{ color: '#2563eb', fontSize: 14 }}>{label}</b>
          {firstItem?.isHazmat && type === 'Pickup' && (
            <Button
              disabled
              sx={{
                ml: 1,
                fontSize: 11,
                height: 25,
                width: 60,
                fontWeight: 'bold',
                backgroundColor: 'red !important',
                color: 'white !important',
                borderRadius: '8px',
                padding: '0 8px',
                cursor: 'default'
              }}
              variant='contained'
              size='small'
            >
              Hazmat
            </Button>
          )}
        </Grid>

        {/* "Shipment Details" header */}
        {isGlobalFirst && type === 'Pickup' && index === 0 && (
          <Grid sx={{ display: 'flex' }}>
            <b style={{ color: '#2563eb' }}>Shipment Details</b>
          </Grid>
        )}

        {/* Item Details for each item in group */}
        {items.map((item, itemIndex) => (
          <React.Fragment key={`${type}-item-${item.id || itemIndex}`}>
            {itemIndex > 0 && <Divider sx={{ my: 2 }} />}
            {renderItemDetailsCard(item, type)}
          </React.Fragment>
        ))}

        {/* Address Card */}
        {renderAddressCard(firstItem, index, type)}

        {/* Contact Details */}
        {type === 'Pickup' &&
          pickupDetailsArr?.[index] &&
          renderPickupContactDetails(pickupDetailsArr[index], index)}
        {type === 'Delivery' &&
          deliveryDetailsArr?.[index] &&
          renderDeliveryContactDetails(deliveryDetailsArr[index], index)}

        {/* Instructions shown once after all deliveries */}
        {type === 'Delivery' &&
          index === Object.entries(groupedDeliveryDetails).length - 1 &&
          renderInstructionsSection()}
      </Grid>
    );
  };

  if (!shipmentsDetails?.length) {
    return null;
  }

  const pickupEntries = Object.entries(groupedPickupDetails);
  const deliveryEntries = Object.entries(groupedDeliveryDetails);
  const hasPickups = pickupEntries.length > 0;
  const hasDeliveries = deliveryEntries.length > 0;

  return (
    <Box sx={{ marginTop: 3 }}>
      <Grid container spacing={2}>
        {/* Render all pickups in sequential order */}
        {hasPickups &&
          pickupEntries.map(([address, items], index) =>
            renderLocationBlock(items, index, 'Pickup', true)
          )}

        {/* Render all deliveries in sequential order at the end */}
        {hasDeliveries &&
          deliveryEntries.map(([address, items], index) =>
            renderLocationBlock(items, index, 'Delivery', !hasPickups)
          )}
      </Grid>
    </Box>
  );
};

export default TLShipmentPreview;
